import React from 'react';
import PermissionNotGrantedMessage from 'components/PermissionNotGrantedMessage';
import { Step } from 'components/SteppedModal';
import SocialShareModalFooterAuthButton from 'containers/SocialShareModal/SocialShareModalFooter/SocialShareModalFooterAuthButton';
import SocialShareModalFooterCancelButton from 'containers/SocialShareModal/SocialShareModalFooter/SocialShareModalFooterCancelButton';
import { SocialShareAccessDeniedStep } from '../types';
import { socialShareModalBlock as block } from '../utils';

export type UseSocialShareAccessDeniedStepConfig = {
  message?: React.ReactNode;
  onCancel: () => void;
};

export default function useSocialShareAccessDeniedStep({
  message,
  onCancel,
}: UseSocialShareAccessDeniedStepConfig): Step<SocialShareAccessDeniedStep> {
  return {
    id: 'access-denied',
    component: (
      <PermissionNotGrantedMessage
        className={block('access-denied')}
        message={message}
      />
    ),
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <SocialShareModalFooterCancelButton key="cancel" onCancel={onCancel} />,
      <SocialShareModalFooterAuthButton key="auth">
        revise options
      </SocialShareModalFooterAuthButton>,
    ],
  };
}
